import { render } from "./Atualizar.vue?vue&type=template&id=f3e8458c"
import script from "./Atualizar.vue?vue&type=script&lang=js"
export * from "./Atualizar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__